export default [
    {
        path: "/voucher/canteen/journal/company-bill-create",
        component: () => import("@/App/Canteen/Voucher/Journal/Components/CompanyBillCreate.vue"),
        name: "voucher.canteen.received.company.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/journal/create",
        component: () => import("@/App/Canteen/Voucher/Journal/Components/Create.vue"),
        name: "voucher.canteen.journal.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/journal/:id/view",
        component: () => import("@/App/Canteen/Voucher/Journal/Components/View.vue"),
        name: "voucher.canteen.journal.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/journal/bank-transfer",
        component: () => import("@/App/Canteen/Voucher/Journal/Components/BankTransfer.vue"),
        name: "voucher-canteen-journal-bank-transfer",
        meta: {
            requiresAuth: true,
        },
    },
];
